import { render, staticRenderFns } from "./PreorderReviewPopup.vue?vue&type=template&id=03b63baa&scoped=true"
import script from "./PreorderReviewPopup.vue?vue&type=script&lang=ts"
export * from "./PreorderReviewPopup.vue?vue&type=script&lang=ts"
import style0 from "./PreorderReviewPopup.vue?vue&type=style&index=0&id=03b63baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b63baa",
  null
  
)

export default component.exports